import { REVERT_TO_DEFAULT_TRUTHY_CART_VALUES } from "../../redux/actions/action.types";

export default function revertToDefaultTCV(stateHandler: any) {
  stateHandler({
    type: REVERT_TO_DEFAULT_TRUTHY_CART_VALUES,
  });
}
